import { Mats } from "@mezo-org/mezo-clay"

import { selectTotalMats, useDappSelector } from "#/redux-state"
import { separateThousandsWithComaRegExp } from "#/shared/utils"

import StatsCard from "./StatsCard"

export default function StatsHodlScoreCard() {
  const totalMats = useDappSelector(selectTotalMats)

  return (
    <StatsCard
      value={
        <>
          {separateThousandsWithComaRegExp(totalMats.toString())} <Mats />
        </>
      }
      title="Your HODL score"
    />
  )
}
